import { StyleInfoCard } from '../style'
import NotificationOrderInfo from './orderInfo'

const NotificationInfoCard = ({ item, onClick }: any) => {
  return (
    <StyleInfoCard
      onClick={() => {
        onClick && onClick(item)
      }}
    >
      {item?.notificationType === 'Lend' && (
        <NotificationOrderInfo item={item} />
      )}
      {item?.notificationType === 'Borrow' && (
        <NotificationOrderInfo item={item} />
      )}
      {item?.notificationType === 'Subscriptions' && (
        <NotificationOrderInfo item={item} />
      )}
      {item?.notificationType === 'Books' && (
        <NotificationOrderInfo item={item} />
      )}
      {item?.notificationType === 'Orders' && (
        <NotificationOrderInfo item={item} />
      )}
    </StyleInfoCard>
  )
}

export default NotificationInfoCard
